export interface BankAccountDetails {
  bank_account_type: string;
  ach_account_number: string;
  ach_routing_number: string;
}

export enum VerificationStatuses {
  NEW = 'new',
  PENDING = 'pending',
  VERIFICATION_FAILED = 'verificationFailed',
  ERRORED = 'errored',
  VERIFIED = 'verified'
}

export interface PaymentProviderBankDetails {
  bank_status: VerificationStatuses;
  bank_account_type: 'checking' | 'savings';
  bank_name: string;
  bank_account_last_4: string;
  routing_number: string;
  verification_locked: boolean;
}

export interface BankAccountStoreState {
  bank_details: PaymentProviderBankDetails
}
